import { render } from "./supplier.vue?vue&type=template&id=7ef8a5e5&scoped=true&ts=true"
import script from "./supplier.vue?vue&type=script&lang=ts"
export * from "./supplier.vue?vue&type=script&lang=ts"

import "./supplier.vue?vue&type=style&index=0&id=7ef8a5e5&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef8a5e5"]])

export default __exports__